import { AnyType } from "./common-types";

/**
 * Error with message.
 */
export interface ErrorWithMessage {
  message: string;
  name?: string;
  status?: number;
  statusText?: string;
}

export function toErrorWithMessage(maybeError: unknown): ErrorWithMessage {
  if (maybeError !== null && typeof maybeError === 'object') {
    if ('error' in maybeError) {
      if (typeof (maybeError as Record<string, unknown>)['error'] === 'string') {
        (maybeError as Record<string, unknown>)['message'] = (maybeError as Record<string, unknown>)['error'];
        return maybeError as unknown as ErrorWithMessage;
      }

      if (typeof (maybeError as Record<string, unknown>)['error'] === 'object') {
        (maybeError as Record<string, unknown>)['message'] = (maybeError as AnyType)['error']['message'];
        return maybeError as unknown as ErrorWithMessage;
      }
    }

    if ('message' in maybeError && typeof (maybeError as Record<string, unknown>)['message'] === 'string') {
      return maybeError as ErrorWithMessage;
    }
  }

  try {
    return new Error(JSON.stringify(maybeError));
  } catch {
    return new Error(String(maybeError));
  }
}

export function getErrorMessage(error: unknown) {
  const err = toErrorWithMessage(error);
  return `${err.statusText} \n ${err.message}`;
}
